module.exports = __webpack_public_path__ + "static/media/Capgdsgture.1d2dfba7.jpg";